module.exports = __webpack_public_path__ + "img/image1.278f8be1.webp";